// eslint-disable-next-line import/prefer-default-export
export const getFavoriteLabwareIds = (state) => state.userPreferenceState.favoriteLabwareIDs;
